export default {
    add_new_topic: "Add new topic",
    confirm_delete_reply: "Are you sure you want to delete your reply?",
    confirm_delete_topic: "Are you sure you want to delete this topic?",
    delete_reply: "Delete reply",
    delete_topic: "Delete topic",
    delete: "Delete",
    edit: "Edit",
    error_changing_answer_status: "Error changing answer status",
    error_changing_topic_status: "Error changing topic status",
    error_deleting_reply: "Error deleting the reply",
    error_deleting_topic: "Error deleting topic",
    error_editing_reply: "Error editing the reply",
    error_editing_topic: "Error editing topic",
    in_this_course: "in this course",
    reply_deleted: "Reply deleted",
    reply_edited: "Reply edited",
    search_topic: "Search topic",
    there_are_no_topics_in_this_course_yet: "There are no topics in this course yet",
    topic_added_successfully: "Topic added successfully",
    topic_deleted: "Topic deleted!",
    topic_edited: "Topic edited",
    topic_is_closed: "This topic is closed and doesn't accept more replies.",
    topic_plural: "topics",
    topic: "topic"
}
